<template>
  <div class="flex flex-row justify-center mb-2 mt-3">
    <div class="md:w-full text-center">
      <p class="text-white">
        <slot>
          <h5 v-if="authStore.getLandingPageLanguage == 'en'" class="text-[12px] md:text-md">
            Please enter your Mobily number and click on “SUBSCRIBE NOW” to receive the verification code.
          </h5>
          <h5 v-if="authStore.getLandingPageLanguage == 'ar'" dir="rtl" class="text-[12px] md:text-md">
            يرجى ادخال رقم موبايلي الخاص بك والنقر على "إشترك الآن" لاستلام رمز التحقق
          </h5>
        </slot>
      </p>
    </div>
  </div>
</template>

<script>
import { useAuthStore } from "@/stores/auth";

export default {
  data() {
    return {
      authStore: useAuthStore(),
    };
  },
};
</script>

<style></style>
